import {
  EntityFragment,
  EntityQuery,
  EntityQueryVariables,
  StandardGetHookOptions,
  useEntityQuery,
  useOnEntityUpdatedSubscription,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

const useEntityImpl = withStandardGetHook<
  EntityQuery,
  EntityFragment,
  'entity',
  EntityQueryVariables
>(useEntityQuery, 'entity');

export const useEntity = (options: StandardGetHookOptions) => {
  useOnEntityUpdatedSubscription();
  return useEntityImpl(options);
};
